import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-bitbot_svg__a"
        d="M12.09 15.284c1.108 0 2.015-.93 2.015-2.065h-4.029c0 1.136.907 2.065 2.015 2.065m-3.626-4.13c-.806 0-1.41.62-1.41 1.446h2.82c0-.826-.705-1.445-1.41-1.445m7.05 0c-.806 0-1.41.62-1.41 1.445h2.72c0-.826-.605-1.445-1.31-1.445m-3.324-6.09c.605 0 1.007-.413 1.007-1.033 0-.62-.402-1.032-1.007-1.032-.604 0-1.007.413-1.007 1.032 0 .62.504 1.033 1.007 1.033m9.568 7.225c-.201-1.445-.604-2.993-.806-4.025-.302-1.24-1.41-2.065-2.618-2.168-1.31 0-3.424-.103-6.244-.103s-4.935.103-6.144.206c-1.31 0-2.417.929-2.72 2.065-.2 1.032-.603 2.477-.805 4.025-.201 1.033-.302 2.168-.403 3.51-.1.723.202 1.445.705 2.065.504.516 1.209.929 2.015.929 1.712.103 4.43.206 7.25.206 2.82 0 5.54-.103 7.252-.206.806 0 1.51-.413 2.014-.93a2.485 2.485 0 00.705-2.064c.101-1.342 0-2.477-.2-3.51zm-1.813 4.13c-.201.206-.403.309-.705.309-2.316.103-4.733.206-7.15.206-2.418 0-4.835-.103-7.151-.206-.302 0-.504-.103-.705-.31-.201-.206-.201-.31-.201-.413.1-1.238.201-2.374.402-3.406.101-1.239.403-2.477.705-3.82.101-.309.403-.515.907-.515a95.073 95.073 0 016.043-.207c2.316 0 4.431.103 6.042.207.403 0 .806.31.806.619.302 1.239.604 2.58.806 3.82.1.928.302 2.064.403 3.406 0 0 0 .103-.202.31z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-bitbot_svg__a"
    />
  </svg>
);
